module.exports = __webpack_public_path__ + "static/03-cd0ad5f57f67ffc73f8b84b0fb2e095f.jpg";